import { Injectable, inject } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation } from '@softline/core';
import { SOFTLINE_API_GARAGE_ROSTER_CONFIG } from '../garage.api';
import { RosterConfig } from '../models/roster-config';

export interface RosterConfigQuery {
  begindate?: string;
  enddate?: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class RosterConfigRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  retrieve(query: RosterConfigQuery = {}): Promise<RosterConfig> {
    const location: ApiResourceLocation = {
      path: SOFTLINE_API_GARAGE_ROSTER_CONFIG,
      queryParams: query,
    };
    return this.#dataAccess.get(location);
  }
}
